module.exports = __webpack_public_path__ + "static/fonts/Mont-RegularItalic.6bf8548.eot";